import { JournalId, GroupTopicId } from 'types';

export const GROUP_TOPICS_BY_WEEK = (journalId: JournalId) =>
    `/api/v1/journals/${journalId}/group-topics/weekly`;
export const GROUP_TOPICS = (journalId: JournalId) => `/api/v1/journals/${journalId}/group-topics`;
export const GROUP_TOPIC = (journalId: JournalId, topicId: GroupTopicId) =>
    `/api/v1/journals/${journalId}/group-topics/${topicId}`;
